import React from 'react'
import Configs, { Theme as ConfigsTheme } from './configs'
import _ from 'lodash'
import styled from 'styled-components'
import { ConfigBar, EditorContainer } from 'plugin-assets/shared/widget/components/styled'
import PreviewAndData from 'plugin-assets/shared/widget/multi-channel/editor/preview-and-data'

export type ChannelsValueEditorProps = ChannelsWidgetEditorProps & {
    data: ChannelValueData
}
type ChannelValueData = ChannelsWidget & {
    jsonConfig: ChannelsWidgetJsonConfig & ChannelsValueJsonConfig
}

export default function AssetEditorFactory(
    widgetConfigStore: Record<string, any>,
    widgetConfigActions: Record<string, any>,
    widgetDataStore: Record<string, any>,
    widgetDataActions: Record<string, any>,
    meta: Array<any>
): (props: ChannelsValueTypeActionProps) => React.ReactNode {
    return function EditorWrapper(props: ChannelsValueTypeActionProps): React.ReactNode {
        return (
            <ChannelsValueEditor
                widgetConfigStore={widgetConfigStore}
                widgetDataActions={widgetDataActions}
                widgetConfigActions={widgetConfigActions}
                widgetDataStore={widgetDataStore}
                meta={meta}
                {...props}
            />
        )
    }
}

export class ChannelsValueEditor extends React.Component<ChannelsValueEditorProps> {
    render(): JSX.Element {
        const selectedAsset = _.get(this.props, 'data.jsonConfig.assets[0].asset')

        const channels = [
            ..._.get(this.props, 'data.jsonConfig.assets[0].channels', []),
            ..._.get(this.props, 'data.jsonConfig.assets[0].calculatedChannels', [])
        ]
        const isEmpty = !selectedAsset || !channels.length

        return (
            <ThemedEditorContainer className="editor-container default-editor">
                <ConfigBar>
                    <Configs
                        widgetConfig={this.props.data.jsonConfig}
                        type={this.props.selectedWidget.type}
                        changeConfig={this.props.widgetConfigActions.changeConfig}
                        changeLayoutConfig={this.props.widgetConfigActions.changeLayoutConfig}
                        isEditor={true}
                    />
                </ConfigBar>
                <PreviewAndData
                    widgetConfigStore={this.props.widgetConfigStore}
                    widgetConfigActions={this.props.widgetConfigActions}
                    widgetDataStore={this.props.widgetDataStore}
                    widgetDataActions={this.props.widgetDataActions}
                    widget={this.props.data}
                    renderPreview={this.props.renderPreview}
                    isEmpty={isEmpty}
                    isAssetSelected={selectedAsset}
                />
            </ThemedEditorContainer>
        )
    }
}
const ThemedEditorContainer = styled(EditorContainer)`
    ${ConfigsTheme} {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
`
